import { render, staticRenderFns } from "./FanComparison.vue?vue&type=template&id=3d683024&scoped=true&"
import script from "./FanComparison.vue?vue&type=script&lang=js&"
export * from "./FanComparison.vue?vue&type=script&lang=js&"
import style0 from "./FanComparison.vue?vue&type=style&index=0&id=3d683024&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d683024",
  null
  
)

export default component.exports